// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WSo9","name":"styles_name__3klHE","phone":"styles_phone__3coyH"};